import * as React from "react"
import { useTranslation } from "react-i18next"

import ERouteAccountant, { workspacePath } from "@/accountant/ERouteAccountant"
import WorkspaceSwitcher from "@/components/Accountant/WorkspaceSwitcher"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "@/components/ui/sidebar"
import { AccountantWorkspace } from "@/types"
import { FileTextIcon, WalletIcon, UsersIcon, UserIcon, LandmarkIcon, PlugIcon } from "lucide-react"

interface AppSidebarProps extends React.ComponentProps<typeof Sidebar> {
  workspaces: AccountantWorkspace[]
  currentWorkspace?: AccountantWorkspace
  email: string
  onSignOut: () => void
}

export function AppSidebar({ workspaces, currentWorkspace, email, onSignOut, ...props }: AppSidebarProps) {
  const { t } = useTranslation()
  const navMain = [
    ...(currentWorkspace ? [
      { title: t('Accountant::Invoices'), url: workspacePath(currentWorkspace.id, 'invoices'), icon: <FileTextIcon /> },
      { title: t('Accountant::Expenses'), url: workspacePath(currentWorkspace.id, 'expenses'), icon: <WalletIcon /> },
      { title: t('Accountant::Transactions'), url: workspacePath(currentWorkspace.id, 'transactions'), icon: <LandmarkIcon /> },
      { title: t('Accountant::Integrations'), url: workspacePath(currentWorkspace.id, 'integrations'), icon: <PlugIcon /> },
    ] : []),
  ]
  const userMenu = [
    { title: t('Accountant::Clients'), url: ERouteAccountant.PATH_CLIENTS, icon: <UsersIcon /> },
    { title: t('Accountant::Account'), url: ERouteAccountant.PATH_ACCOUNT, icon: <UserIcon /> },
  ]

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <WorkspaceSwitcher workspaces={workspaces} currentWorkspace={currentWorkspace} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser email={email} items={userMenu} onSignOut={onSignOut} />
      </SidebarFooter>
    </Sidebar>
  )
}
